const meta = new URL(document.currentScript.src);
export const SDK_TOKEN = meta.searchParams.get('sdk_token');

// NOTE:
// 為節省 Fingerprint Pro API 請求次數
// 上層 (CMS) 可能會透過網址將 FingerprintProId 傳過來
// 若取不到值表示上層也沒有 FingerprintProId，或是沒有上層、純 Tracker 的環境
// REF: https://17media.atlassian.net/l/cp/2Xcr1sc2
export const FINGERPRINT_PRO_ID = meta.searchParams.get('fp_id');
